/* TALU Magnetic Buttons - 2026-05-19
   Efecto de "boton magnetico": el boton sigue suavemente al cursor
   con un offset proporcional + scale sutil. Desktop (mouse) y mobile (touch).
   Aplicable a: .btn-now, .btn-buy-now en cta-stack.
*/
(function () {
  'use strict';

  var SELECTOR = '.btn-now, .btn-buy-now';
  var STRENGTH_X = 0.18;
  var STRENGTH_Y = 0.28;
  var TOUCH_X = 0.12;
  var TOUCH_Y = 0.20;
  var SCALE_HOVER = 1.04;
  var SCALE_TOUCH = 1.03;

  function reset(btn) {
    btn.style.transform = '';
  }

  // Un movimiento del dedo o del mouse dispara decenas de eventos por segundo, y
  // cada uno hacía un getBoundingClientRect (leer posición = obligar al navegador
  // a recalcular el layout) seguido de una escritura de estilo. Ese vaivén de
  // leer-escribir es de lo más caro que se le puede pedir al hilo principal, y
  // ocurre justo mientras la persona interactúa — que es lo que mide el INP.
  // Ahora los eventos se acumulan y se aplica UNO por frame: el resultado en
  // pantalla es idéntico, porque el navegador no pinta más rápido que eso.
  var pendiente = null;
  var agendado = false;

  function programarMove(btn, clientX, clientY, sx, sy, scl) {
    pendiente = { btn: btn, x: clientX, y: clientY, sx: sx, sy: sy, scl: scl };
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      var p = pendiente;
      pendiente = null;
      if (p) applyMove(p.btn, p.x, p.y, p.sx, p.sy, p.scl);
    });
  }

  function applyMove(btn, clientX, clientY, sx, sy, scl) {
    var rect = btn.getBoundingClientRect();
    var dx = clientX - rect.left - rect.width / 2;
    var dy = clientY - rect.top - rect.height / 2;
    var tx = dx * sx;
    var ty = dy * sy;
    btn.style.transform = 'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0) scale(' + scl + ')';
  }

  function bind(btn) {
    if (btn.__taluMagnetic) return;
    btn.__taluMagnetic = true;

    // Forzar transition suave (sobre-escribe el !important de overrides via inline style)
    btn.style.transitionProperty = 'transform, box-shadow, background';
    btn.style.transitionDuration = '420ms';
    btn.style.transitionTimingFunction = 'cubic-bezier(.16,.85,.28,1)';
    btn.style.willChange = 'transform';

    btn.addEventListener('mousemove', function (e) {
      programarMove(btn, e.clientX, e.clientY, STRENGTH_X, STRENGTH_Y, SCALE_HOVER);
    });
    btn.addEventListener('mouseleave', function () {
      reset(btn);
    });
    btn.addEventListener('mousedown', function () {
      btn.style.transitionDuration = '180ms';
    });
    btn.addEventListener('mouseup', function () {
      btn.style.transitionDuration = '420ms';
    });

    // Touch (mobile)
    btn.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      var t = e.touches[0];
      programarMove(btn, t.clientX, t.clientY, TOUCH_X, TOUCH_Y, SCALE_TOUCH);
    }, { passive: true });
    btn.addEventListener('touchmove', function (e) {
      if (!e.touches[0]) return;
      var t = e.touches[0];
      programarMove(btn, t.clientX, t.clientY, TOUCH_X, TOUCH_Y, SCALE_TOUCH);
    }, { passive: true });
    btn.addEventListener('touchend', function () {
      reset(btn);
    });
    btn.addEventListener('touchcancel', function () {
      reset(btn);
    });
  }

  function scan() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return; // accesibilidad
    }
    scan();

    // El observador vigila TODO el body, así que despierta con cualquier cambio de
    // la página: el carrito, los widgets de las apps, el carrusel de reseñas al
    // poner sus tarjetas. Antes, cada aviso disparaba un querySelectorAll sobre el
    // documento entero. Una ráfaga de 50 cambios costaba 50 recorridas.
    // Ahora se agrupan y queda UNA por frame — el resultado es el mismo, porque
    // los botones nuevos igual quedan enlazados antes del siguiente pintado.
    var scanAgendado = false;
    function scanDiferido() {
      if (scanAgendado) return;
      scanAgendado = true;
      requestAnimationFrame(function () {
        scanAgendado = false;
        scan();
      });
    }
    var obs = new MutationObserver(scanDiferido);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
